import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

export const Principles = () => {
  const { t } = useLang();
  return (
    <section className="bg-pastel-blue py-14 md:py-20 border-y border-ser-blue/10" data-testid="principles-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <Overline>{t.howWeWork.overline}</Overline>
          <h2 className="font-display text-3xl md:text-4xl leading-tight tracking-tight text-navy mt-4">
            {t.principles.title}
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-8">
          {t.principles.items.map((p, i) => (
            <Reveal key={p} delay={0.05 * i}>
              <div className="flex items-start gap-3">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-ser-purple shrink-0" aria-hidden="true" />
                <p className="text-sm md:text-base font-medium text-navy/80">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
